// G5E — rótulos e metadados para a UI de relacionamentos (contato ↔ empresa/imóvel).
// Fonte do contrato: RPC resolve_email_relationship_context / curate_contact_relationship.

// match_method ∈ approved_relationship | contact_curated | contact_no_empresa |
//               from_domain | from_website | partner_domain_unresolved | none
export const MATCH_METHOD_META = {
  approved_relationship:     { label: 'Relação aprovada',        color: 'bg-emerald-100 text-emerald-700' },
  contact_curated:           { label: 'Curado no contato',       color: 'bg-emerald-100 text-emerald-700' },
  contact_no_empresa:        { label: 'Contato sem empresa',     color: 'bg-amber-100 text-amber-700' },
  from_domain:               { label: 'Inferido pelo domínio',   color: 'bg-blue-100 text-blue-700' },
  from_website:              { label: 'Inferido pelo site',      color: 'bg-blue-100 text-blue-700' },
  partner_domain_unresolved: { label: 'Domínio de parceiro (sem relação curada)', color: 'bg-orange-100 text-orange-700' },
  none:                      { label: 'Sem relação curada',      color: 'bg-slate-100 text-slate-600' },
};

export function matchMethodMeta(method) {
  return MATCH_METHOD_META[method] || { label: method || '—', color: 'bg-slate-100 text-slate-600' };
}

// Estados em que não há relação curada → habilitam o CTA de curadoria no card do inbox.
export const UNCURATED_METHODS = ['partner_domain_unresolved', 'none'];

// Fallback para humanizar valores de papel quando o dicionário do banco ainda não carregou.
export function humanizeRole(value) {
  if (!value) return '—';
  return String(value).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
